import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { FIELD_KEYS } from '_constants/forms';
import { REPORT_KEYS } from '_constants/reports';
import { theme } from '_constants/theme';
import { selectFilters } from '_store/reports/selector';
import { updateFilters } from '_store/reports/slice';

import DateFilter from 'components/atomic/filters/DateFilter';
import ReconcileFilter from 'components/atomic/filters/ReconcileFilter';
import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.regular}px;
  margin-bottom: ${theme.spaces.largeX}px;

  > * {
    &:last-child {
      min-width: 140px;
    }
  }

  @media ${theme.devices.tablet} {
    flex-direction: column;
    gap: ${theme.spaces.smallX}px;

    > * {
      width: 100%;
    }
  }
`;

const Filters = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectFilters(REPORT_KEYS.bankTransactions));

  const handleSelect = (filter) => {
    dispatch(
      updateFilters({
        [REPORT_KEYS.bankTransactions]: {
          ...filters,
          ...filter,
        },
      })
    );
  };

  return (
    <StyledContainer>
      <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
        From:
      </Text>
      <DateFilter name={FIELD_KEYS.from} value={filters[FIELD_KEYS.from]} onSelect={handleSelect} />
      <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
        To:
      </Text>
      <DateFilter name={FIELD_KEYS.to} value={filters[FIELD_KEYS.to]} onSelect={handleSelect} />
      <Text size={theme.fontSizes.smallX} weight={600} color={theme.colors.gray.secondary}>
        Show:
      </Text>
      <ReconcileFilter name={FIELD_KEYS.reconcile} value={filters[FIELD_KEYS.reconcile]} onSelect={handleSelect} />
    </StyledContainer>
  );
};

export default Filters;
